import { CHILDREN_AGE_ERROR_MESSAGE, INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE, WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE } from '../constants';
function useTravelerError({
  children,
  childrenAges,
  lapInfants,
  ageSelectEnabled,
  isInternationalFlight,
  isWhiteLabel,
  shouldAllowInternationalLapInfants
}) {
  const infantAgeCount = childrenAges ?
  // @ts-ignore
  Object.values(childrenAges).reduce((carry, age) => carry + (parseInt(age) === 0), 0) : 0;
  const infantCount = lapInfants + infantAgeCount;
  const childrenLengthsDoNotMatch = childrenAges && Object.keys(childrenAges).length !== children;
  const hasEmptyChildrenAges = childrenAges && Object.values(childrenAges).findIndex(value => value === '') !== -1;
  const hasChildrenAgeError = ageSelectEnabled && children > 0 && (childrenLengthsDoNotMatch || hasEmptyChildrenAges);
  const isInternationalFlightLapInfantError = !shouldAllowInternationalLapInfants && isInternationalFlight && infantCount > 0;
  if (hasChildrenAgeError) {
    return CHILDREN_AGE_ERROR_MESSAGE;
  } else if (isInternationalFlightLapInfantError) {
    return isWhiteLabel ? WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE : INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE;
  }
  return null;
}
export default useTravelerError;